<template>
  <div>
    <appointmentService :downTitle="downTitle"></appointmentService>
  </div>
</template>

<script>
import appointmentService from '../appointmentService'

export default {
  components: {appointmentService},
  data() {
    return {
      downTitle: ''
    };
  },
  created() {
    this.downTitle = this.$route.query.title
  },
  methods: {}
};
</script>

<style lang="less" scoped>
// 页面所有非输入框元素 彻底无光标、无焦点、无选中框

</style>